import(/* webpackMode: "eager" */ "/tmp/8dee7fca0d68e48/components/sections/CtaSection.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8dee7fca0d68e48/components/sections/FAQSection.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8dee7fca0d68e48/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dee7fca0d68e48/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dee7fca0d68e48/components/sections/KeyTakeawaysSection.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dee7fca0d68e48/components/sections/SourcesSection.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dee7fca0d68e48/app/[locale]/staff-shortage-hospitality/StaffShortagePage.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dee7fca0d68e48/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/tmp/8dee7fca0d68e48/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/tmp/8dee7fca0d68e48/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/tmp/8dee7fca0d68e48/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
